import React from 'react';

function Header({ text }) {
  return <h1>{text}</h1>;
}

export default Header;
